import image1 from '../images/memberships/Enmascarar grupo 7.png';
import diamond from '../images/memberships/diamond.png';

const memberships = [
	// {
	// 	id: 0,
	// 	image: image1,
	// 	icon: diamond,
	// 	title: 'Estandar',
	// 	prices: [
	// 		{
	// 			price: '985.598 COP',
	// 		},
	// 		{
	// 			price: '899 SOLES',
	// 		},
	// 		{
	// 			price: '219 Euros',
	// 		},
	// 		{
	// 			price: '228.499 ARS',
	// 		},
	// 		{
	// 			price: '4.599 MXN',
	// 		},
	// 		{
	// 			price: '349 USD',
	// 		},
	// 	],
	// 	priceUSD: '349 USD',
	// 	price_before: {
	// 		CO: '1.565.932 COP',
	// 		PE: '1.519 SOLES',
	// 		EC: '399 USD',
	// 		ES: '374 Euros',
	// 		AR: '362.168 ARS',
	// 		MX: '6.892 MXN',
	// 		ALL: '449 USD',
	// 	},
	// 	items: [
	// 		{
	// 			item: '3 meses de entrenamiento',
	// 			more: null,
	// 		},
	// 		{
	// 			item: 'Material de ayuda',
	// 			more: null,
	// 		},
	// 		{
	// 			item: 'Certificación universitaria',
	// 			more: null,
	// 		},
	// 		{
	// 			item: 'Acceso 1 año',
	// 			more: null,
	// 		},
	// 		{
	// 			item: 'Acceso Discord',
	// 			more: null,
	// 		},
	// 		{
	// 			item: 'Acceso Zoom',
	// 			more: null,
	// 		},
	// 	],
	// 	urls: [
	// 		{
	// 			name: 'Pagar con PayPal',
	// 			url: 'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTM0OSZpZD1WYWNhY2lvbmFsIGVuIEJsZW5kZXIgRXN04W5kYXIgY29uIEZlZWRiYWNrIC0gUFc=',
	// 			Viviana: 'https://wa.link/sarakb',
	// 			Julian: 'https://wa.link/g32ron',
	// 			Andres: 'https://wa.link/4vkv45',
	// 		},
	// 		{
	// 			name: 'Pagar con Tarjeta',
	// 			url: 'https://checkout.wompi.co/l/3IW9xp',
	// 			Viviana: 'https://wa.link/sarakb',
	// 			Julian: 'https://wa.link/g32ron',
	// 			Andres: 'https://wa.link/4vkv45',
	// 		},
	// 	],
	// },
	{
		id: 1,
		image: image1,
		icon: diamond,
		title: 'Grow',
		prices: [
			{
				price: '1.250.155 COP',
			},
			{
				price: '1.209 SOLES',
			},
			{
				price: '297 Euros',
			},
			{
				price: '288.616 ARS',
			},
			{
				price: '5.384 MXN',
			},
			{
				price: '429 USD',
			},
		],
		pagos: '3 pagos de',
		priceUSD: '$151 USD',
		off: '40% Dto',
		price_before: {
			CO: '1.565.932 COP',
			PE: '1.519 SOLES',
			EC: '399 USD',
			ES: '374 Euros',
			AR: '362.168 ARS',
			MX: '6.892 MXN',
			ALL: '715 USD',
		},
		items: [
			{
				item: 'Aprende a tu ritmo',
				more: null,
			},
			{
				item: 'Material de ayuda',
				more: null,
			},
			{
				item: 'Cursos de regalo',
				more: null,
			},
			{
				item: 'Certificado por Libel Academy',
				more: null,
			},
			{
				item: 'Acceso 1 año',
				more: null,
			},
		],
		urls: [
			{
				name: 'Pagos Internacionales',
				url: 'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTE1MSZpZD0xZXIgcGFnbyBCbGVuZGVyIEp1bmlvciBQcm8gLSBOaXhhcmlvbiBQVw==',
				Viviana: 'https://wa.link/sarakb',
				Andres: 'https://wa.link/4vkv45',
			},
			{
				name: 'Pagos Colombia',
				url: 'https://checkout.wompi.co/l/fUuQWj',
				Viviana: 'https://wa.link/sarakb',
				Andres: 'https://wa.link/4vkv45',
			},
		],
	},
];

export default memberships;
